import { LANGUAGE_LABELS } from "../consts/i18n";
import i18n from "../i18";

export const getLanguageLabel = (languageCode) => {
  return LANGUAGE_LABELS[languageCode] || languageCode;
};

export const getAllLanguageOptions = () => {
  const languageCodes = i18n.options.supportedLngs.slice(0, 4);

  return languageCodes.map((code) => {
    return LANGUAGE_LABELS[code];
  });
};

export const getLabelCode = (label) => {
  const languageCodes = {};
  for (const [code, label] of Object.entries(LANGUAGE_LABELS)) {
    languageCodes[label] = code;
  }

  return languageCodes[label];
};
